/** @jsx jsx */

import { jsx, render, Query, SelectionSet, Field, EnumScalar } from "graphql-jsx";
import { clients } from "utils/clients";
import { ValidTypeScalar } from "GraphQL/Scalars";
import { ValidType } from "constants/ValidType";

export const GetMoodList = async () => {
  const $remove = <ValidTypeScalar value={ValidType.REMOVE} />;
  const { query, variables } = render(
    <Query operationName="GET_MOOD_INFO">
      <SelectionSet
        name="genre"
        argument={{
          first: 999,
          group: true,
          orderBy: <EnumScalar type="GenreOrderByInput" value="name__ASC" items={["name__ASC"]} />,
          where: {
            weight: 0,
            type_kind: "mood",
            valid_check__not: $remove
          }
        }}
      >
        <Field name="genre_id" alias="id" />
        <Field name="name" />
        <Field name="type_kind" alias="typeKind" />
        {/* genre_self_relation_child alias 에러 있음. */}
        <SelectionSet name="genre_self_relation_child">
          <SelectionSet name="genre_self_relation_parent" alias="parent">
            <Field name="genre_id" alias="id" />
          </SelectionSet>
        </SelectionSet>
      </SelectionSet>
    </Query>
  );
  type Data = {
    genre: {
      id: string;
      name: string;
      typeKind: string;
      genre_self_relation_child?: {
        parent?: {
          id: string;
        }[];
      }[];
    }[];
  };
  return await clients.genre.request<Data>(query, variables);
};
